import { render, staticRenderFns } from "./pastOrder.vue?vue&type=template&id=289a0e78&scoped=true&"
import script from "./pastOrder.vue?vue&type=script&lang=js&"
export * from "./pastOrder.vue?vue&type=script&lang=js&"
import style0 from "./pastOrder.vue?vue&type=style&index=0&id=289a0e78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a0e78",
  null
  
)

export default component.exports